import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Website/Footer.css';

function Footer() {
  const footerLinks = {
    forexTrading: [
      { name: 'Accounts Overview', path: '/accounts-overview' },
      { name: 'Open an Account', path: '/open-account' },
      { name: 'Launch Web Trader', path: '/launch-web-trader' },
      { name: 'Cybersecurity and Scams', path: '/cybersecurity-scams' }
    ],
    tradingSpecs: [
      { name: 'Spreads and Commissions', path: '/spreads-commissions' },
      { name: 'Range of Products', path: '/range-of-products' },
      { name: 'Trading Hours', path: '/trading-hours' },
      { name: 'Funding', path: '/funding' },
      { name: 'Withdrawal', path: '/withdrawal' }
    ],
    about: [
      { name: 'Help Centre', path: '/help-centre' },
      { name: 'Why BGI Assets', path: '/why-BGI Assets' },
      { name: 'Regulation', path: '/regulation' },
      { name: 'Legal Documents', path: '/legal-documents' },
      { name: 'Contact Us', path: '/contact-us' }
    ]
  };

  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-main">
        <div className="container-wide">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-column">
              <div className="footer-logo">
                <div className="logo-icon-footer">
                  <div className="bar bar1"></div>
                  <div className="bar bar2"></div>
                  <div className="bar bar3"></div>
                </div>
                <div className="logo-text-footer">
                  <span className="ic-text">BGI Assets</span>
                </div>
              </div>
              <p className="footer-description">
              BGI Assets mission is to create the best trading experience for retail and 
                institutional clients alike, allowing traders to focus more on their trading. Built by 
                traders for traders BGI Assets is dedicated to offering superior spreads, 
                execution and service.
              </p>
              
              {/* Social Icons */}
              <div className="social-icons">
                <a href="#twitter" className="social-icon" aria-label="Twitter">
                  <span>𝕏</span>
                </a>
                <a href="#instagram" className="social-icon" aria-label="Instagram">
                  <span>📷</span>
                </a>
                <a href="#facebook" className="social-icon" aria-label="Facebook">
                  <span>f</span>
                </a>
              </div>

              {/* TradingView Badge */}
              <div className="tradingview-badge">
                <div className="tv-logo">TV</div>
                <div className="tv-text">
                  <span className="tv-trade">TRADE ON</span>
                  <span className="tv-name">TradingView</span>
                </div>
              </div>
            </div>

            {/* Forex Trading Links */}
            <div className="footer-column">
              <h4 className="footer-heading">Forex Trading</h4>
              <ul className="footer-links">
                {footerLinks.forexTrading.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Trading Specifications Links */}
            <div className="footer-column">
              <h4 className="footer-heading">Trading Specifications</h4>
              <ul className="footer-links">
                {footerLinks.tradingSpecs.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* About IC Markets Links */}
            <div className="footer-column">
              <h4 className="footer-heading">About BGI Assets</h4>
              <ul className="footer-links">
                {footerLinks.about.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container-wide">
          <div className="footer-bottom-content">
            {/* Trustpilot */}
            <div className="trustpilot-rating">
              <span className="excellent-text">Excellent</span>
              <div className="stars">
                <span>⭐⭐⭐⭐⭐</span>
              </div>
              <span className="trustpilot-text">★ Trustpilot</span>
            </div>

            {/* Action Buttons */}
            <div className="footer-actions">
              <Link to="/open-account" className="btn-footer-account">Open an Account</Link>
              <Link to="/contact-us" className="btn-footer-support">
                💬 24/7 Support
              </Link>
            </div>
          </div>

          {/* Legal Text */}
          <div className="footer-legal">
            <p>
            BGI Assets is the trading name of Raw Trading Ltd, which is regulated by the 
              Seychelles Financial Services Authority (FSA) with Securities Dealer's license number SD018.
            </p>
            <p className="copyright">
              © {new Date().getFullYear()} BGI Assets. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;